import { createApi } from '@/api'

export default {
  getConsulationList: config => createApi(`/news/get`, 'post', config), // 获取咨询列表
  getConsulationDetail: config => createApi(`/news/detail`, 'get', config), // 获取咨询详情
  updateConsulation: config => createApi(`/news/save`, 'post', config), // 保存咨询信息
  deleteConsulation: config => createApi(`/news/delete?newsId={id}`, 'post', config), // 删除咨询信息
  batchDeleteConsulation: config => createApi(`/news/deleteBatch `, 'post', config) // 批量删除咨询信息
}



// WEBPACK FOOTER //
// ./src/views/consultation/api/index.js